import React, { useState, useEffect } from 'react';
import { db } from '../firebase/config';
import { doc, getDoc } from 'firebase/firestore';
import './About.css';

function About() {
  const [aboutContent, setAboutContent] = useState({
    aboutEyebrow: 'Who we are',
    aboutTitle: 'Our story',
    aboutParagraph1: 'THE TAG began in 2017 with a desire to create refined abayas that feel effortless. We blend understated luxury with precise tailoring, resulting in silhouettes that move with quiet confidence.',
    aboutParagraph2: 'Every garment is touched by artisans who understand proportion, drape, and the importance of subtle detail. We design limited capsules to ensure attention to every stitch and to keep our collections intentionally curated.',
    aboutButton: 'Learn more',
    aboutImage: 'https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=800&q=80',
  });

  useEffect(() => {
    const fetchAboutContent = async () => {
      try {
        const homepageRef = doc(db, 'homepage', 'content');
        const docSnap = await getDoc(homepageRef);
        if (docSnap.exists()) {
          const data = docSnap.data();
          setAboutContent({
            aboutEyebrow: data.aboutEyebrow || aboutContent.aboutEyebrow,
            aboutTitle: data.aboutTitle || aboutContent.aboutTitle,
            aboutParagraph1: data.aboutParagraph1 || aboutContent.aboutParagraph1,
            aboutParagraph2: data.aboutParagraph2 || aboutContent.aboutParagraph2,
            aboutButton: data.aboutButton || aboutContent.aboutButton,
            aboutImage: data.aboutImage || aboutContent.aboutImage,
          });
        }
      } catch (error) {
        console.error('Error fetching about content:', error);
      }
    };
    fetchAboutContent();
  }, []);

  return (
    <section className="about-section" id="about">
      <div className="about-leaf"></div>
      <div className="container">
        <div className="about-card">
          <div className="about-card__image">
            <div className="about-card__photo" style={{ backgroundImage: `url(${aboutContent.aboutImage})` }}></div>
          </div>
          <div className="about-card__content">
            <p className="about-card__eyebrow">{aboutContent.aboutEyebrow}</p>
            <h2>{aboutContent.aboutTitle}</h2>
            <p>{aboutContent.aboutParagraph1}</p>
            <p>{aboutContent.aboutParagraph2}</p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;

